export default {"src":"/_next/static/media/transit-bus.80f3a653.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};